import ActivitySupportRequest from "@/components/ActivitySupportRequest.vue";
import AppButton from "@/components/AppButton.vue";
import ImageUploader from "@/components/ImageUploader.vue";
import ModalCodigo from "@/components/ModalCodigo.vue";
import OpenImage from "@/components/OpenImage.vue";
import Request from "@/ts/Request";
import moment from "moment";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    ImageUploader,
    AppButton,
    ModalCodigo,
    ActivitySupportRequest,
    OpenImage,
  },
})
export default class SupportRequestDetails extends Vue {
  supportRequest: any = JSON.parse(
    sessionStorage.getItem("SUPPORT_REQUEST") || "{}"
  );
  activities: any = [];
  description = "";
  thisImage = "";
  file: any = [];
  showDeleteAction = false;
  oldInputValue: any = $("#file").val();
  alert = false;
  isImagem = false;
  userId: any = sessionStorage.getItem("USER_ID");
  originalHeight: any;
  msg = "";
  refreshInterval: any;
  showModalImageUp = false;
  $refs!: {
    chatContainer: HTMLDivElement;
  };

  scrollToEnd(): void {
    this.$nextTick(() => {
      const container = this.$refs.chatContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  }

  mounted() {
    this.getActivities(this.supportRequest.id);
    this.originalHeight = $("#textarea1").height();
    this.loopConsultMensagem();
    this.scrollToEnd();
  }

  @Watch("activities")
  onActivitiesChanged() {
    this.scrollToEnd();
  }

  getActivities(id: number) {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        SUPPORT_REQUEST_ID: id,
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
      };
      req.route = "getActivityRequestByNrorgAndSupportRequest";
      req.callbackSuccess = function (response: any) {
        self.activities =
          response.response.activityRequest.length > 0
            ? self.factoryActivities(response.response.activityRequest)
            : "";
        self.focusInput("lastMessage");
      };
      req.callbackError = function (error: any) {};
      req.showLoader = false;
      req.blockTouchEvents = true;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }

  focusInput(elClass: any) {
    const offset = -60;
    const el: any = document.getElementsByClassName(elClass);
    setTimeout(function () {
      el[0].scrollIntoView();
    }, 150);
  }

  openThisImage(ulr: string) {
    OpenImage.openModal("image-modal", ulr);
  }

  factoryActivities(activities: any) {
    const self = this;
    activities.forEach((element: any) => {
      element.date = moment(element.createdAt.date)
        .lang("pt-br")
        .format("DD [de] MMMM, hh[h]mm");
      element.side = self.userId == element.userId;
    });
    return activities;
  }

  goBack() {
    this.$router.go(-1);
  }

  newPreviewFiles(f: any) {
    setTimeout(function () {
      $("#blah").attr("src", f);
    }, 500);
    this.isImagem = true;
    this.file = f;
    this.showDeleteAction = true;
    this.oldInputValue = f;
    this.closeModalImageUp();
  }

  deleteImage() {
    this.file = [];
    this.showDeleteAction = false;
  }

  openModalImageUp() {
    this.showModalImageUp = true;
  }

  closeModalImageUp() {
    this.showModalImageUp = false;
  }

  cleanInputFile() {
    const self = this;
    const control = $("#file");
    control.replaceWith(control.val(""));
    this.file = [];
    self.showDeleteAction = false;
  }

  alertModal(mensagem: string) {
    this.alert = true;
    this.msg = mensagem;
  }

  createActivity() {
    if (this.description == "" && this.file == "") {
      this.alertModal("Favor digitar uma mensagem ou anexar alguma imagem.");
      return 0;
    }

    try {
      const self = this;
      const req = new Request();
      req.body = {
        SUPPORT_REQUEST_ID: self.supportRequest.id,
        USER_ID: sessionStorage.getItem("USER_ID"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        NRORG: sessionStorage.getItem("NRORG"),
        ACTIVITY_REQUEST_OLD_ID: self.activities[self.activities.length - 1].id,
        DESCRIPTION: self.description,
        FILE: self.file,
        TYPE: "Response",
      };
      req.route = "createActivityRequest";
      req.callbackSuccess = function (response: any) {
        self.cleanInputFile();
        self.getActivities(self.supportRequest.id);
        self.description = "";
        $("#textarea1").height(self.originalHeight);
      };
      req.callbackError = function (error: any) {
        if (error.response.data.errorCode == 234) {
          self.alertModal("Favor anexar apenas imagens.");
        } else
          self.alertModal(
            "Ocorreu um erro inesperado ao enviar a solicitação. Tente novamente mais tarde."
          );
      };
      req.send();
    } catch (e) {
      console.log(e);
      const mensagem =
        "Ocorreu um erro desconhecido. Por favor, tente de novo mais tarde";
    }
  }

  loopConsultMensagem() {
    this.refreshInterval = setInterval(() => {
      this.getActivities(this.supportRequest.id);
    }, 8000);
  }

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  }
}
